import { C } from "../../utils/constants";
import { REQUEST_STATUSES } from "../../utils/enums";
import { GLYPH } from "../../utils/glyphs";
import { fmtDateLocal, fmtDateTimeLocal, formatRef } from "../../utils/helpers";
import { Badge } from "../form/FormUI.jsx";

export function RequestTitleBar({
  req,
  status,
  // THE FENCE (RequestDetail): the Zephyr title bar (with the internal "View / Add
  // Comments" button) shows for ANY internal viewer — responder, picker processing a
  // task, OR a picker browsing All Requests read-only. A shelter caseworker gets the
  // shelter title bar, whose comment affordance lives in ShelterRequestView's panel.
  isZephyr,
  notes,
  docs,
  invoices,
  setShowCommentPanel,
  setShowFilesPanel,
  totalChildren,
}) {
  return isZephyr ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 18,
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <div>
        <h1 style={{ margin: 0, fontSize: 22, color: "#1A2E2B" }}>
          {`Request ${formatRef(req.refNo)}`}
        </h1>
        <p style={{ margin: "4px 0 0", color: "#607D79", fontSize: 14 }}>
          {/* State is intentionally omitted — the DFV Service code already encodes it
              (e.g. ZephyrNSW003 is NSW). */}
          {req.shelterCode || ""}
          {req.shelterCode ? " - " : ""}
          {req.status === REQUEST_STATUSES.DRAFT || req.refNo?.startsWith("DRAFT")
            ? "Created"
            : "Submitted"}{" "}
          {req.createdAt ? fmtDateTimeLocal(req.createdAt) : fmtDateLocal(req.date)}
        </p>
      </div>
      {/* marginLeft: auto keeps the action row right-aligned even when the wider
          responder button set wraps below the title (matches the shelter view). */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
          marginLeft: "auto",
        }}
      >
        <button
          onClick={function () {
            setShowCommentPanel(true);
          }}
          style={{
            background: "#00695C",
            color: "white",
            border: "none",
            borderRadius: 7,
            padding: "9px 18px",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "inherit",
            display: "flex",
            alignItems: "center",
            gap: 6,
            whiteSpace: "nowrap",
          }}
        >
          {GLYPH.speech} View / Add Comments
          {notes.length > 0 && (
            <span
              style={{
                background: "rgba(255,255,255,0.25)",
                borderRadius: 10,
                padding: "1px 7px",
                fontSize: 11,
                fontWeight: 700,
              }}
            >
              {notes.length}
            </span>
          )}
        </button>
        <button
          onClick={function () {
            setShowFilesPanel(true);
          }}
          style={{
            background: C.teal,
            color: "white",
            border: "none",
            borderRadius: 7,
            padding: "9px 18px",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "inherit",
            display: "flex",
            alignItems: "center",
            gap: 6,
            whiteSpace: "nowrap",
          }}
        >
          {GLYPH.paperclip} Files &amp; Invoices
          {(function () {
            var dc = (docs || []).filter(function (f) {
              return (
                f &&
                (typeof f === "string" ? !f.endsWith(".html") : f.url && !f.name.endsWith(".html"))
              );
            }).length;
            var ic = (invoices || []).filter(Boolean).length;
            return (
              <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                {
                  <span
                    style={{
                      background: "rgba(255,255,255,0.25)",
                      borderRadius: 10,
                      padding: "1px 7px",
                      fontSize: 11,
                      fontWeight: 700,
                    }}
                    title="Documents"
                  >
                    Files {dc}
                  </span>
                }
                {
                  <span
                    style={{
                      background: "rgba(255,255,255,0.25)",
                      borderRadius: 10,
                      padding: "1px 7px",
                      fontSize: 11,
                      fontWeight: 700,
                    }}
                    title="Invoices"
                  >
                    Inv {ic}
                  </span>
                }
              </span>
            );
          })()}
        </button>
        <Badge
          status={status}
          style={{
            fontSize: 18,
            padding: "10px 28px",
            fontWeight: 800,
            letterSpacing: 0.5,
          }}
        />
      </div>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 18,
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <div>
        <h1 style={{ margin: 0, fontSize: 22, color: "#1A2E2B" }}>
          {`Request ${formatRef(req.refNo)}`}
        </h1>
        <p style={{ margin: "4px 0 0", color: "#607D79", fontSize: 14 }}>
          {req.shelterRef ? `${req.shelterRef} — ` : ""}
          {req.status === REQUEST_STATUSES.DRAFT || req.refNo?.startsWith("DRAFT")
            ? "Created"
            : "Submitted"}{" "}
          {req.createdAt ? fmtDateTimeLocal(req.createdAt) : fmtDateLocal(req.date)}
          {totalChildren > 0 ? ` — ${totalChildren} child${totalChildren !== 1 ? "ren" : ""}` : ""}
        </p>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        {/* Draft "Continue Editing" lives ONLY in the yellow draft banner
            (RequestDetailBanners) — the duplicate title-bar button was removed
            6 Jul 2026 (John's call: same action, one button is enough). */}
        {/* The shelter Comments button moved into the "Latest Update from Zephyr"
            panel header in ShelterRequestView (John's call, 5 Jul 2026) — no
            comment affordance in the shelter title bar. Staff branch unchanged. */}
        {/* Files are added during request creation in the wizard; a draft uses
            Continue Editing, so no separate file affordance is shown here. */}
        {!(req.status === REQUEST_STATUSES.DRAFT || req.refNo?.startsWith("DRAFT")) && (
          <button
            onClick={function () {
              setShowFilesPanel(true);
            }}
            style={{
              background: C.teal,
              color: "white",
              border: "none",
              borderRadius: 7,
              padding: "9px 18px",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit",
              display: "flex",
              alignItems: "center",
              gap: 6,
              whiteSpace: "nowrap",
            }}
          >
            {`${GLYPH.paperclip} Files & Invoices`}
            {(function () {
              var dc = (docs || []).filter(function (f) {
                return (
                  f &&
                  (typeof f === "string"
                    ? !f.endsWith(".html")
                    : f.url && !f.name.endsWith(".html"))
                );
              }).length;
              var ic = (invoices || []).filter(Boolean).length;
              return (
                <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  {
                    <span
                      style={{
                        background: "rgba(255,255,255,0.25)",
                        borderRadius: 10,
                        padding: "1px 7px",
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                      title="Documents"
                    >
                      Files {dc}
                    </span>
                  }
                  {
                    <span
                      style={{
                        background: "rgba(255,255,255,0.25)",
                        borderRadius: 10,
                        padding: "1px 7px",
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                      title="Invoices"
                    >
                      Inv {ic}
                    </span>
                  }
                </span>
              );
            })()}
          </button>
        )}
        <Badge
          status={status}
          style={{
            fontSize: 18,
            padding: "10px 28px",
            fontWeight: 800,
            letterSpacing: 0.5,
          }}
        />
      </div>
    </div>
  );
}
